function FlashOn({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 10 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0V11H3V20L10 8H6L9 0H0Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default FlashOn;
